import type { ChatCategory } from '@/contexts/chat/scripts/hooks/useChats/types';
import type { InfoProps } from '@/contexts/session/context';

export enum TagTypes {
  DESTROY = 'DESTROY',
  VECTOR = 'VECTOR',
  KEYERROR = 'KEYERROR',
}

export type MyAvatarProps = {
  className?: string;
  size?: 'small' | 'medium' | 'mediumPlus' | 'large' | 'extraLarge';
  src: string;
  tagType?: TagTypes;
  expireDuration?: number;
  category?: ChatCategory;
  info?: InfoProps;
  showProfileClick?: boolean;
  stopPropagation?: boolean;
  onClick?: () => void;
};
